<template>
    <div>
        <div class="row">

            <div class="col-12">
                <div class="card">
                    <div class="card-body">

                        <button type="button" style="float: right" data-bs-toggle="modal"
                            data-bs-target="#associateProductModal" class="btn btn-sm btn-primary px-5">Add
                            Product</button>
                        <p><strong>Name: </strong>{{ pickinglist.name }}</p>
                        <p><strong>Description: </strong>{{ pickinglist.description }}</p>

                        <table class="table">
                            <thead>
                                <tr>
                                    <th>
                                        Product
                                    </th>
                                    <th>
                                        Quantity
                                    </th>
                                    <th>Associated Products</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="product in products" :key="'p-' + product.product_id">
                                    <td>
                                        {{ product.name }}
                                    </td>
                                    <td>
                                        {{ product.quantity }}
                                    </td>
                                    <td>
                                        <div v-for="child in product.associatedProducts"
                                            :key="'c-' + child.child_product_id">
                                            {{ child.name }} (x{{ child.quantity }})
                                        </div>
                                    </td>
                                    <td>
                                        <button class="btn btn-sm btn-danger" @click="remove(product.id)">Remove</button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                    </div>
                </div>
            </div>

            <!-- MODALS -->

            <div class="modal fade" id="associateProductModal" tabindex="-1" style="display: none;" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">Create Product</h5>
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-md-12 mb-2">
                                    <p>Fields marked <span class="text-danger">*</span> are required</p>
                                </div>
                                <div class="col-md-12 mb-2">
                                    <label for="productName" class="form-label">Product <span
                                            class="text-danger">*</span></label>
                                    <Multiselect v-model="product.product_id" id="newChildProduct" valueProp="id"
                                        label="name" :searchable="true" :options="allProducts">
                                    </Multiselect>
                                </div>
                                <div class="col-md-12 mb-2">
                                    <label for="productType" class="form-label">Quantity <span
                                            class="text-danger">*</span></label>
                                    <input type="number" min="0.00" step="1" class="form-control" id="productQuantity"
                                        v-model="product.quantity">
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"
                                id='closeAssociateProductModal'>Close</button>
                            <submit-button type="button" :background="'btn btn-primary'" @click="associateProduct"
                                text="Save changes"></submit-button>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
/* global $ */
import axios from 'axios';
import SubmitButton from "../../../components/SubmitButton";
import Multiselect from '@vueform/multiselect';

export default {
    name: 'admin.pickinglist.list.view',
    props: ['id'],
    components: {
        Multiselect,
        SubmitButton
    },
    data() {
        return {
            pickinglist: {
                name: "",
                description: ""
            },
            product: {
                product_id: "",
                quantity: 1
            },
            products: [],
            allProducts: [],
            edit: false,
            updating: false,
            question: ""
        }
    },
    mounted() {
        this.load();
        this.loadProducts();
        this.loadAllProducts()
    },
    methods: {
        load() {
            axios.get(`${process.env.VUE_APP_API_URL}/v1/product/pickinglist/${this.id}`)
                .then(response => {
                    this.pickinglist.name = response.data.pickingList.name;
                    this.pickinglist.description = response.data.pickingList.description;
                })
                .catch(error => {
                    this.$error("Failed to load picking list.", error);
                })
        },
        loadProducts() {
            axios.get(`${process.env.VUE_APP_API_URL}/v1/product/pickinglist/${this.id}/products`)
                .then(response => {
                    console.log(response.data);
                    this.products = response.data.products;
                })
                .catch(error => {
                    this.$error("Failed to load products.", error);
                })
        },
        loadAllProducts() {
            axios.get(`${process.env.VUE_APP_API_URL}/v1/product/list`)
                .then(response => {
                    this.allProducts = response.data.products;
                })
                .catch(error => {
                    this.$error("Failed to load products.", error);
                })
        },
        associateProduct() {
            axios.post(`${process.env.VUE_APP_API_URL}/v1/product/pickinglist/${this.id}/products`, {
                product_id: this.product.product_id,
                quantity: this.product.quantity
            })
                .then(() => {
                    this.$success("Product added successfully.");
                    $("#associateProductModal").modal("hide");
                    this.product.product_id = "";
                    this.product.quantity = 1;
                    this.products = [];
                    this.loadProducts();
                })
                .catch(error => {
                    this.$error("Failed to add product.", error);
                });
        },
        remove(id) {
            axios.delete(`${process.env.VUE_APP_API_URL}/v1/product/pickinglist/${this.id}/${id}`)
                .then(() => {
                    this.products = [];
                    this.loadProducts();
                    this.$success("Product deleted.");
                })
                .catch(error => {
                    this.$error("Failed to delete product.", error);
                })
        },
    }
}
</script>